<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog } from "../stores/LoggerStore";
  import SettingsMgr, { officialThemes } from "../stores/SettingsMgr";
  import { get } from "svelte/store";

  export let winProps: WinProps;
  winProps.name = winProps.name || "Styler";
  const setProps = () => {
    if (!winProps.data) {
      winProps.data = {};
    }
    winProps.data["rect"] = winProps.data["rect"] || {
      left: "50%",
      width: "400px",
      // heightRatio: 1,
      aspectRatio: 1 / 1.6,
    };
  };
  setProps();

  const thememgr = SettingsMgr.getInstance();
  const _theme = thememgr.theme;
  const set1 = (e) => thememgr.setTheme("default");
  const set2 = (e) => thememgr.setTheme("glass");
  const possibleThemes = officialThemes();

  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    // contElem.style.setProperty("background-color", c["2"]);
    // titleElem.style.setProperty("color", c["1"]);
  };
  $: watcher = themeWatcher($_theme);
  let contElem: HTMLElement, titleElem: HTMLElement;
  onMount(() => {
    themeWatcher($_theme);
  });
  let prevTheme = get(_theme).name;
  let intro = "Click to Apply!";
</script>

<Window {winProps}>
  <div class="container" bind:this={contElem}>
    <h1 class="title" bind:this={titleElem}>Styler</h1>
    <p>Hover on themes to preview</p>
    <p class="intro">{intro}</p>
    {#each possibleThemes as theme (theme.name)}
      <button
        style={`background-color:${theme.colors[2]};color:${theme.colors[1]}`}
        class="btn"
        on:mouseenter={() => {
          prevTheme = get(_theme).name;
          thememgr.setTheme(theme.name);
        }}
        on:mouseleave={() => {
          thememgr.setTheme(prevTheme);
        }}
        on:click={() => {
          prevTheme = theme.name;
          thememgr.setTheme(theme.name);
          intro = `Style set to ${theme.name}!`;
        }}>{theme.name}</button
      >
    {/each}
  </div>
</Window>

<style>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .btn {
    margin: 0 auto;
    width: 90%;
    line-height: 1.1rem;
    font-size: 1rem;
    transition: 0.2s;
  }
  .btn:hover {
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 600;
  }
  .btn:active {
    transition: 0s;
    border: 5px solid #333;
  }
  p {
    margin: 15px auto;
  }
</style>
